export default __webpack_public_path__ + "static/media/251033.6606e9f0.png";